const disableScroll = () => {
  const scrollY = (document.body.style.top = `-${window.scrollY}px`);
  document.body.style.position = "fixed";
  document.body.style.top = scrollY + "px";
  document.body.style.left = 0;
  document.body.style.right = 0;

  setTimeout(() => {
    document.documentElement.style.scrollBehavior = "unset";
  }, 400);
};

export default disableScroll;



// WEBPACK FOOTER //
// ./scripts/modules/disable-scroll.js